'use strict'

export default (mockAxios) => {
  mockAxios.onGet(`/input-proxy-settings`).reply(200, {
    'success': true,
    'data': {
      'default_input_proxy': '1'
    }
  })

  mockAxios.onPut(`/input-proxy-settings`).reply(201, {
    'success': true,
    'data': {}
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/inputProxySettingsRepositoryMock.js